export default __webpack_public_path__ + "static/media/cart-img.abc92768.jpg";